import config from 'config';
import axios from '@mobile/util/axios';
import _ from 'lodash';

export const localStorageUserKey = 'user';
export const localStorageTokenKey = 'token';

export const authHeader = function () {
    // return authorization header with jwt token
    const token = userToken();

    if (token && token.token) {
        return { Authorization: `Bearer ${token.token}` };
    }
    return {};
};

export const loggedInUser = function () {
    return JSON.parse(localStorage.getItem(localStorageUserKey));
};

export const userToken = function () {
    return JSON.parse(localStorage.getItem(localStorageTokenKey));
};

export const loggedIn = function () {
    return localStorage.getItem(localStorageTokenKey) !== null;
};

export const updateUser = (user = {}) => localStorage.setItem(localStorageUserKey, JSON.stringify(user));

function login(email, password) {
    return axios.post(
        `${config.apiUrl}/${config.apiVersion}/authenticate/login`,
        { email, password },
    ).then(({ data: token }) => {
        localStorage.setItem(localStorageTokenKey, JSON.stringify(token));
        return token;
    });
}

function me() {
    return axios.get(
        `${config.apiUrl}/${config.apiVersion}/authenticate/me`,
        { headers: authHeader() },
    ).then(({ data: user }) => {
        if (!user.timezone) {
            let timezone = 'Europe/Berlin';
            try {
                timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            } catch (e) {
                // Intl unavailable, fall back to default value;
            }
            user.timezone = timezone;
        }
        localStorage.setItem(localStorageUserKey, JSON.stringify(user));
        return user;
    });
}

function requestPasswordResetLink(email) {
    return axios.get(
        `${config.apiUrl}/${config.apiVersion}/authenticate/password/reset`,
        { params: { email } },
    ).then(({ data: token }) => token);
}

function resetPassword(email, password, password_confirmation, token) {
    return axios.put(
        `${config.apiUrl}/${config.apiVersion}/authenticate/password/reset`,
        {
            email, password, password_confirmation, token,
        },
    ).then((response) => response);
}

export function logout() {
    // blacklist current jwt token
    return axios.post(`${config.apiUrl}/${config.apiVersion}/authenticate/logout`, {}, {
        headers: authHeader(),
    }).then(() => {
        // delete current jwt token
        localStorage.removeItem(localStorageTokenKey);
        localStorage.removeItem(localStorageUserKey);
    });
}

export const updateUserSubscription = (subscription = {}) => {
    const user = JSON.parse(localStorage.getItem(localStorageUserKey));
    _.set(user, 'subscription', subscription);
    localStorage.setItem(localStorageUserKey, JSON.stringify(user));
};
export const updateUserSubscriptionInspections = (inspection = {}) => {
    const user = JSON.parse(localStorage.getItem(localStorageUserKey));
    _.set(user, 'subscription.inspections', inspection);
    localStorage.setItem(localStorageUserKey, JSON.stringify(user));
};

export const userService = {
    login,
    logout,
    me,
    resetPassword,
    requestPasswordResetLink,
    loggedIn,
    loggedInUser,
    updateUser,
    updateUserSubscription,
    updateUserSubscriptionInspections,
};
